/**
 * Normalizes a phone number by removing all non-digit characters.
 * Adds the US country code (+1) when the number contains exactly
 * 10 digits. Otherwise, prefixes the number with a plus sign.
 *
 * @param {string} phone - The phone number to normalize.
 * @returns {string} The normalized phone number, or an empty string
 * if no digits are present.
 */
export function normalizePhone(phone) {
	const digits = (phone || '').replace(/\D/g, '');
	if (!digits) {
		return '';
	}
	return digits.length === 10 ? `+1${digits}` : `+${digits}`; // US default
}
